import axios from "axios";
import { useReactToPrint } from "react-to-print";
import logo from '../../images/food.jpg';

import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { Modal } from 'react-bootstrap';

const LoansReport = forwardRef((props, ref) => {
  const [loans, setLoans] = useState([]);
  const [inviteModal, setInviteModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [totalAmount, setTotalAmount] = useState(0);

  const componentRef = useRef();

  // Print to PDF
  const generatePDF = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "LoansReport",
    onAfterPrint: () => alert("تم حفظ البيانات كـ PDF")
  });

  useImperativeHandle(ref, () => ({
    showInviteModal() {
      fetchLoans();
      setInviteModal(true);
    }
  }));

  // Fetch loans + filter by month
  const fetchLoans = async () => {
    try {
      const response = await axios.get("https://suhba.education.com.ly/back/api/getloans");
      const allLoans = response.data.Receiptexpenses;

      let filteredLoans = allLoans;

      if (selectedMonth) {
        filteredLoans = allLoans.filter((loan) => {
          const loanMonth = new Date(loan.ExpenseDate).toISOString().slice(0, 7); // "YYYY-MM"
          return loanMonth === selectedMonth;
        });
      }

      const sum = filteredLoans.reduce((acc, loan) => acc + parseFloat(loan.Amount || 0), 0);

      setLoans(filteredLoans);
      setTotalAmount(sum);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  // Clear filters
  const clearFilters = () => {
    setSelectedMonth();
    fetchLoans(); // fetch all again
  };

  return (
    <>
      <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel1">ديون الموظفين</h1>
            <button type="button" className="btn-close" style={{ marginLeft: 0 }} onClick={() => setInviteModal(false)}></button>
          </div>

          <div className="modal-body" dir="rtl" ref={componentRef}>
            {/* Month Filter */}
            <div className="d-flex gap-2 mb-3 align-items-center justify-content-start">
              <label className="form-label mb-0">الشهر:</label>
              <input
                type="month"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="form-control"
                placeholder="yyyy-mm"
                style={{ width: "200px" }}
              />
              <button className="btn btn-sm btn-primary" onClick={fetchLoans}>
                بحث
              </button>
              <button className="btn btn-sm btn-secondary" onClick={clearFilters}>
                مسح الفلتر
              </button>
            </div>

            {/* Loans Table */}
            <table className="invoice-table">
              <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                <tr>
                  <th>الموظف</th>
                  <th>تاريخ السلفة</th>
                  <th>القيمة</th>
                                          <th>ملاحظة</th>
                  
                </tr>
              </thead>
              <tbody>
                {loans.length > 0 ? (
                  loans.map((loan, index) => (
                    <tr key={index}>
                      <td>{loan.comp_employee ? loan.comp_employee.FirstName : '—'}</td>
                      <td>{loan.ExpenseDate}</td>
                      <td>{loan.Amount}</td>
                                    <td>{loan.Status}</td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-danger fw-bold">
                      ❗ لعرض البيانات، قم باستخدام الفلترة بالشهر
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Total Amount */}
            {loans.length > 0 && (
              <div className="text-end fw-bold mt-3">
                المجموع: <span className="text-danger">{totalAmount.toFixed(2)} د.ل</span>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-danger light" onClick={() => setInviteModal(false)}>إلغاء</button>
            <button className="btn btn-success" onClick={generatePDF}>طباعه</button>
          </div>
        </div>
      </Modal>
    </>
  );
});

export default LoansReport;
